import React, { useState } from 'react';
import { C as CarouselComponent } from '../../Carousel-sE6CEZCp.js';
import { L as Lightbox } from '../../Lightbox--QyVxi3g.js';
import 'next/router';
import '../../a11y-f6LwtRzd.js';
import '../../context/index.js';
import '../../utils/logToSlack.js';
import '../../animations--PMkOS0j.js';
import '../../_commonjsHelpers-jjO7Zipk.js';
import '../../index-RkBJ48Nr.js';
import 'cookies-next';
import '../../breakpoints-X1SKRYyW.js';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-a4IKjS7g.js';
import '../../index-dEXHnASi.js';
import 'i18next';
import 'react-i18next';
import '../../index-itNs9E93.js';
import 'notistack';
import 'next-i18next';
import '../../utils/logToRelic.js';
import '../../hooks/useWindowSize.js';
import 'lodash/get';
import '../../product-_pRduMz7.js';
import '../../helpers-WYINLSKJ.js';
import '../../utils/product.js';
import '../../utils/logger.js';
import '../../paths-ZKN3m62_.js';
import '../../cookies-VX_DpI1q.js';
import 'lodash';
import '../Modal/index.js';
import '../OnlyUIRender/index.js';
import '../Modal/ModalContent/index.js';
import 'react-dom';
import '../../index-2586sEvh.js';
import '../../hooks/useAutoFocus.js';
import '../../hooks/useGetPortalRoot.js';
import '../../utils/portalRoot.js';
import '../FocusTrap/index.js';
import '../IconButton/index.js';
import '../Modal/ModalHeader/index.js';

const ImagesCarousel = ({ items = [], thumbnailImage = '', title = '', preview = [''], }) => {
    const [showImageIndexModal, setShowImageIndexModal] = useState(-1);
    return (React.createElement(React.Fragment, null,
        React.createElement(CarouselComponent, { items: items, thumbnailImage: thumbnailImage || null, title: title, setShowImageIndexModal: setShowImageIndexModal, preview: preview }),
        showImageIndexModal >= 0 && (React.createElement(Lightbox, { items: items, currentImageIndex: showImageIndexModal, onClose: () => setShowImageIndexModal(-1), title: title }))));
};

export { ImagesCarousel as default };
//# sourceMappingURL=index.js.map
